import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingDAO } from '../../../../core/services/dao/bookingDAO';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { AdminAccess } from '../../../shared/accessAdmin';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss'],
})
export class BookingsComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public subs: Subscription[] = [];
  public columnDefs;
  public rowData;
  public editPath;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userDAO: UserDAO,
    private bookingDAO: BookingDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.editPath = 'manage/admin/bookings/edit';
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
    const dataSub = this.route.data.subscribe((data) => {
      this.columnDefs = this.createColumnDefs();
      this.rowData = data.portal.bookingResolve;
    });
    this.subs.push(dataSub);
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'Date/Time',
        field: 'arrivalTime',
        width: 210,
        filter: 'text',
      },
      {
        headerName: 'Captain First Name',
        field: 'captain.user.firstName',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'Captain Last Name',
        field: 'captain.user.lastName',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'Passenger First Name',
        field: 'passenger.firstName',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'Passenger Last Name',
        field: 'passenger.lastName',
        filter: 'text',
        minWidth: 50,
      },
      {
        headerName: 'Captain Email',
        field: 'captain.user.email',
        filter: 'text',
      },
      {
        headerName: 'Passenger Email',
        field: 'passenger.email',
        filter: 'text',
      },
      {
        headerName: 'Captain Phone',
        field: 'captain.user.phoneNumber',
        filter: 'text',
      },
      {
        headerName: 'Passenger Phone',
        field: 'passenger.phoneNumber',
        filter: 'text',
      },
      {
        headerName: 'Duration',
        field: 'duration',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'Street',
        field: 'arrivalStreet',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'City',
        field: 'arrivalCity',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'State',
        field: 'arrivalState',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'Zip',
        field: 'arrivalZip',
        minWidth: 50,
        filter: 'text',
      },
      {
        headerName: 'Notes',
        field: 'arrivalNotes',
        filter: 'text',
      },
      {
        headerName: 'Price',
        field: 'bookingTotal',
        minWidth: 40,
        filter: 'text',
      },
      {
        headerName: 'Paid?',
        field: 'paid',
        minWidth: 40,
        filter: 'boolean',
      },
    ];
  }
}
